/**
 * Slider
 */

// Module Dependencies
import 'protons';
import $ from 'jquery';
import 'slick-carousel/slick/slick';

// Module styles
import './_slider.scss';
import 'slick-carousel/slick/slick.scss';

export const name = 'slider';

export function disable() {}

function resetImages(event, slick) {
  slick.$slider.find('.slide').each((index, slide) => {
    const $slide = $(slide);
    $slide.css('background-image', $slide.attr('data-image'));
  });
}

export function enable() {
  const $allSlider = $('.slider');
  if ($allSlider.is('.slick-initialized')) return;
  $allSlider.each((i, el) => {
    const slider = $(el);
    const nav = slider.next();
    let { autoplaySpeed } = slider.data();
    autoplaySpeed = typeof autoplaySpeed === 'number' ? autoplaySpeed * 1000 : 4000;

    nav.on('click', 'li', (event) => {
      const clickedIndex = $(event.currentTarget).index();
      slider.slick('slickGoTo', clickedIndex);
    }).children().eq(0).addClass('active');

    slider.on('breakpoint', resetImages);
    slider.on('init', resetImages);
    slider.slick({
      // Test: Settings from https://github.com/kenwheeler/slick/
      verticalSwiping: true,
      vertical: true,
      autoplay: true,
      autoplaySpeed,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            verticalSwiping: false,
            vertical: false,
            adaptiveHeight: true,
          },
        },
      ],
      prevArrow: '<button class="slider__button slider__button--prev">&#x25C0;&#xFE0E;</button>',
      nextArrow: '<button class="slider__button slider__button--next">&#x25B6;&#xFE0E;</button>',
    }).on('afterChange', (event, slick, currentSlide) => {
      nav.children().removeClass('active').eq(currentSlide).addClass('active');
    });
  });
}

export default enable;
